module.exports = __webpack_public_path__ + "img/union2.d6ce9e5b.png";